"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartClear = exports.cartChangeNote = exports.cartChangeAttribute = exports.cartChangeTipsAmount = exports.cartChangeTipsPercent = exports.cartRemoveItem = exports.cartRemoveItemQuantity = exports.cartChangeOrder = exports.cartAddItemQuantity = exports.cartAddOrder = exports.BASKET_CLEAR = exports.CHANGE_NOTE = exports.CHANGE_ATTRIBUTE = exports.CHANGE_TIPS_AMOUNT = exports.CHANGE_TIPS_PERCENT = exports.REMOVE_ITEM = exports.REMOVE_ITEM_QUANTITY = exports.CHANGE_ITEM = exports.ADD_ITEM_QUANTITY = exports.ADD_ITEM = void 0;
exports.ADD_ITEM = 'basket/ADD_ITEM';
exports.ADD_ITEM_QUANTITY = 'basket/ADD_ITEM_QUANTITY';
exports.CHANGE_ITEM = 'basket/CHANGE_ITEM';
exports.REMOVE_ITEM_QUANTITY = 'basket/REMOVE_ITEM_QUANTITY';
exports.REMOVE_ITEM = 'basket/REMOVE_ITEM';
exports.CHANGE_TIPS_PERCENT = 'basket/CHANGE_TIPS_PERCENT';
exports.CHANGE_TIPS_AMOUNT = 'basket/CHANGE_TIPS';
exports.CHANGE_ATTRIBUTE = 'basket/CHANGE_ATTRIBUTE';
exports.CHANGE_NOTE = 'basket/CHANGE_NOTE';
exports.BASKET_CLEAR = 'basket/BASKET_CLEAR';
var cartAddOrder = function (product, quantity) { return ({ type: exports.ADD_ITEM, product: product, quantity: quantity }); };
exports.cartAddOrder = cartAddOrder;
var cartAddItemQuantity = function (itemIndex) { return ({ type: exports.ADD_ITEM_QUANTITY, itemIndex: itemIndex }); };
exports.cartAddItemQuantity = cartAddItemQuantity;
var cartChangeOrder = function (product, quantity, id) { return ({ type: exports.CHANGE_ITEM, product: product, quantity: quantity, id: id }); };
exports.cartChangeOrder = cartChangeOrder;
var cartRemoveItemQuantity = function (itemIndex) { return ({ type: exports.REMOVE_ITEM_QUANTITY, itemIndex: itemIndex }); };
exports.cartRemoveItemQuantity = cartRemoveItemQuantity;
var cartRemoveItem = function (itemIndex) { return ({ type: exports.REMOVE_ITEM, itemIndex: itemIndex }); };
exports.cartRemoveItem = cartRemoveItem;
var cartChangeTipsPercent = function (tip) { return ({ type: exports.CHANGE_TIPS_PERCENT, tip: tip }); };
exports.cartChangeTipsPercent = cartChangeTipsPercent;
var cartChangeTipsAmount = function (amount) { return ({ type: exports.CHANGE_TIPS_AMOUNT, amount: amount }); };
exports.cartChangeTipsAmount = cartChangeTipsAmount;
var cartChangeAttribute = function (attribute, value) { return ({ type: exports.CHANGE_ATTRIBUTE, attribute: attribute, value: value }); };
exports.cartChangeAttribute = cartChangeAttribute;
var cartChangeNote = function (value) { return ({ type: exports.CHANGE_NOTE, value: value }); };
exports.cartChangeNote = cartChangeNote;
var cartClear = function () { return ({ type: exports.BASKET_CLEAR }); };
exports.cartClear = cartClear;
